module.exports = __webpack_public_path__ + "static/media/Landing-1.6b1cd3d8.jpg";